// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602201134/js/" + chunkId + "." + {"44":"1260d451","225":"93668e48","481":"a492f07f","486":"bf4538a1","770":"4171b59b"}[chunkId] + ".0.7491135147170664.chunk.js";
};